<template>
  <el-dialog
    :title="$t('service statement')"
    :visible.sync="visible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    width="720px"
  >
    <div v-if="statement" v-html="statement.content" class="statement-content"></div>
    <el-checkbox v-model="agreed">{{ $t("i've read the notice aboved") }}</el-checkbox>
    <span slot="footer">
      <el-button v-if="statement && statement.mode === 'yearly'" @click="handleReject" :disabled="!agreed">{{ $t('reject') }}</el-button>
      <el-button type="primary" @click="handleAccept" :disabled="!agreed">{{ $t('accept') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { eventBus } from '@/router'

export default {
  name: 'StatementDialog',
  data() {
    return {
      visible: false,
      statement: null,
      agreed: false
    }
  },
  mounted() {
    eventBus.$on('show-statement-dialog', this.show)
  },
  beforeDestroy() {
    eventBus.$off('show-statement-dialog', this.show)
  },
  methods: {
    show(statement) {
      this.statement = statement
      this.agreed = false
      this.visible = true
    },
    handleAccept() {
      this.visible = false
      eventBus.$emit('statement-accepted', this.statement)
    },
    handleReject() {
      this.visible = false
      eventBus.$emit('statement-rejected', this.statement)
    }
  }
}
</script>

<style scoped>
.statement-content {
  max-height: 400px;
  overflow-y: auto;
  margin-bottom: 15px;
}
</style>
